// Vavetek design tokens, taken from vavetek.ai: Poppins, brand gold #CC9A39, black header, cream sections.
// Use these (or the MUI theme built from them) instead of hard-coded colours.

export const colors = {
  gold: '#CC9A39', // primary actions, accents
  goldDark: '#B3862F', // hover / pressed for gold
  goldText: '#8C6A1F', // gold used as text on white (readable contrast)
  beige: '#FAF3E8', // selected / tinted surfaces
  beigeHover: '#F4EADB',
  cream: '#FFF5DF', // highlight panels

  black: '#000000', // top bar
  ink: '#171717', // headings, strong text
  text: '#3B3B3B', // body text
  muted: '#6B6B6B', // secondary text
  border: '#E7E2D9',
  inputBorder: '#D9D3C7',
  page: '#F8F6F1', // app background
  surface: '#FFFFFF', // cards

  success: '#1E7B34',
  successBg: '#E6F4EA',
  warning: '#A15C00',
  warningBg: '#FFF4E5',
  error: '#B3261E',
  errorBg: '#FDECEA',
  info: '#1F5F8B',
  infoBg: '#E8F1F8',
};

export const radius = {
  control: 10, // buttons, inputs, menu items
  card: 14, // cards, dialogs
};

export const fontFamily = "'Poppins', 'Segoe UI', Arial, sans-serif";

export const layout = {
  topBarHeight: 64,
  sidebarWidth: 248,
};
